module.exports = __webpack_public_path__ + "static/media/petshealth-3.8abcf3b0.png";